import React from 'react';
import {
  Box,
  Typography,
  Chip,
} from '@mui/material';
import BackButton from '../components/ui/BackButton';
import { useAuth } from '../context/AuthContext';
import TeacherActivityTracker from '../components/admin/TeacherActivityTracker';
import { StyledCard } from '../components/ui/StyledComponents';

function TeacherActivityPage() {
  const { userRole } = useAuth();

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <BackButton to="/admin" label="Back to Dashboard" />
        <Typography variant="h4" component="h1">
          Teacher Activity Tracking
          {userRole === 'super_admin' && (
            <Chip 
              label="Super Admin" 
              color="secondary" 
              size="small" 
              sx={{ ml: 2 }}
            />
          )}
        </Typography>
      </Box>

      <StyledCard>
        <TeacherActivityTracker />
      </StyledCard>
    </Box>
  );
}

export default TeacherActivityPage;
